import { ColumnType } from 'lib/ng-data-table';
import { Column } from 'lib/ng-crud-table';
import { colSpecialCharsPipe } from '../pipes/data-cols.pipe';


export function changeAlias(value: string): string {
  let repVal = value.replace(/DTD/g, ".");//7 underscores
  repVal = repVal.replace(/MNS/g, "-");//6 underscores
  repVal = repVal.replace(/PCG/g, "%");//5 underscores
  repVal = repVal.replace(/SLH/g, "/");//4 underscores
  repVal = repVal.replace(/ZYX/g, ")").replace(/XYZ/g, "(");//3, 2 underscores
  repVal = repVal.replace(/\_/g, " ");
  repVal = repVal.replace(/Point1/g, "Point(secs)");
  repVal = repVal.replace(/Point2/g, "Point(secs)");
  repVal = repVal.replace(/Point3/g, "Point(secs)");
  repVal = repVal.replace(/Point4/g, "Point(secs)");
  repVal = repVal.replace(/ERL1/g, "ERL(dB)");
  repVal = repVal.replace(/ERL2/g, "ERL(dB)");
  repVal = repVal.replace(/ERL3/g, "ERL(dB)");
  repVal = repVal.replace(/ERL4/g, "ERL(dB)");
  repVal = repVal.replace(/Delay1/g, "Delay(ms)");
  repVal = repVal.replace(/Delay2/g, "Delay(ms)");
  repVal = repVal.replace(/Delay3/g, "Delay(ms)");
  repVal = repVal.replace(/Delay4/g, "Delay(ms)");
  return repVal;
}
export function GetMapColumnAliia(strColumnName, rsltTypeChk, DDLorGrid) {
  var strColumnAlia;
  var chkVACOrNetTestOrPhoneInfo = 0;
  if (rsltTypeChk.indexOf('nettest') != -1 || rsltTypeChk.indexOf('conndrop') != -1 ||
    rsltTypeChk.indexOf('mobileinfo') != -1 || rsltTypeChk.indexOf('vac') != -1)
    chkVACOrNetTestOrPhoneInfo = 1;
  switch (strColumnName.toLowerCase()) {
    //case "user_id": 
    //    strColumnAlia = "File ID"; 
    //    break;  
    case "vquad_timestamp":
      strColumnAlia = "Timestamp";  //"VQuad Timestamp"; /////Renaming all VQuad included columns to generic for both VQuad and vMobile
      if (chkVACOrNetTestOrPhoneInfo == 1)
        strColumnAlia = "Device Timestamp (End)";
      break;
    case "call_timestamp":
      strColumnAlia = "Call Timestamp";
      break;
    case "vqt_timestamp":
      strColumnAlia = "VQT Timestamp";
      break;
    case "calltype_orig":
      strColumnAlia = "Call Type Originating";
      break;
    case "calltype_term":
      strColumnAlia = "Call Type Terminating";
      break;
    case "vquad_callid":
      strColumnAlia = "Event ID";// "VQuad Event ID"; /////Renaming all VQuad included columns to generic for both VQuad and vMobile
      break;
    case "location":
    case "vquad_location":
      strColumnAlia = "Call ID";  ///"VQuad Call ID";  /////Renaming all VQuad included columns to generic for both VQuad and vMobile
      break;
    case "gps_lat":
      strColumnAlia = "Latitude";
      if (chkVACOrNetTestOrPhoneInfo == 1)
        strColumnAlia = "Device Latitude (End)";
      break;
    case "gps_long":
      strColumnAlia = "Longitude";
      if (chkVACOrNetTestOrPhoneInfo == 1)
        strColumnAlia = "Device Longitude (End)";
      break;
    case "vquad_lat_long":
    case "gps_position":
    case "vquad_gps":
      strColumnAlia = "GPS"; /// "VQuad GPS"; /////Renaming all VQuad included columns to generic for both VQuad and vMobile
      if (chkVACOrNetTestOrPhoneInfo == 1)
        strColumnAlia = "Device GPS (End)";
      break;
    case "phone_id":
    case "vquad_phoneid":
      strColumnAlia = "Device ID"; ///"VQuad Device ID"; /////Renaming all VQuad included columns to generic for both VQuad and vMobile
      break;

    //PESQ
    case "pesq":
    case "pesq_score":
      strColumnAlia = "PESQ";
      break;
    case "speech_level_gain":
      strColumnAlia = "Speech Level Gain (dB)";
      break;
    case "noise_level_gain":
      strColumnAlia = "Noise Level Gain (dB)";
      break;
    case "pesq_mos":
      strColumnAlia = "PESQ LQO";
      break;
    case "clipping":
    case "number_all_clipping":
      strColumnAlia = "Number All Clipping";
      break;
    case "pesq_avg_offset":
    case "pesq_average_offset":
      strColumnAlia = "PESQ Average Offset (ms)";
      break;
    case "pesq_offset_confidence":
      strColumnAlia = "PESQ Offset Confidence (%)";
      break;
    case "pesq_max_offset":
      strColumnAlia = "PESQ Max Offset (ms)";
      break;
    case "pesq_min_offset":
      strColumnAlia = "PESQ Min Offset (ms)";
      break;
    case "pesq_std_deviation_offset":
      strColumnAlia = "PESQ Standard Deviation Offsets (ms)";
      break;
    case "pesq_std_deviation_offset_":
      strColumnAlia = "PESQ Standard Deviation Offsets - Other (ms)";
      break;
    case "pesq_proportion_degraded_muted":
      strColumnAlia = "PESQ Proportion degraded muted (%)";
      break;
    case "pesq_max_mute":
      strColumnAlia = "PESQ Max Mute (ms)";
      break;
    case "pesq_median_offset":
      strColumnAlia = "PESQ Median Offset (ms)";
      break;
    case "pesq_max_offset_":
      strColumnAlia = "PESQ Max Offset - Other (ms)";
      break;
    case "pesq_min_offset_":
      strColumnAlia = "PESQ Min Offset - Other (ms)";
      break;
    case "pesq_median_offset_":
      strColumnAlia = "PESQ Median Offset - Other (ms)";
      break;
    case "pesq_average_offset_":
      strColumnAlia = "PESQ Average Offset - Other (ms)";
      break;
    case "pesq_offset_confidence_":
      strColumnAlia = "PESQ Offset Confidence - Other (%)";
      break;
    case "proportion_muted":
      strColumnAlia = "Proportion muted (%)";
      break;
    case "longest_muted":
      strColumnAlia = "Longest muted (ms)";
      break;
    case "proportion_all_clipping":
      strColumnAlia = "Proportion All clipping (%)";
      break;
    case "duration_all_clipping":
      strColumnAlia = "Duration ALL Clipping (s)";
      break;
    case "mean_duration_all_clipping":
      strColumnAlia = "Mean Duration ALL Clipping (s)";
      break;
    case "offset":
    case "avg_jitter":
    case "average_jitter":
      strColumnAlia = "Average Jitter (ms)";
      break;
    case "mean_dc_reference":
      strColumnAlia = "Mean DC reference (dBov)";
      break;
    case "asl_reference":
      strColumnAlia = "ASL reference (dBov)";
      break;
    case "mean_noise_reference ":
      strColumnAlia = "Mean noise reference (dBov)";
      break;
    case "rms_reference":
      strColumnAlia = "RMS reference (dBov)";
      break;
    case "mean_dc_degraded":
      strColumnAlia = "Mean DC degraded (dBov)";
      break;
    case "asl_degraded":
      strColumnAlia = "ASL degraded (dBov)";
      break;
    case "mean_noise_degraded":
      strColumnAlia = "Mean noise degraded (dBov)";
      break;
    case "rms_degraded":
      strColumnAlia = "RMS degraded (dBov)";
      break;
    case "duration_of_speech":
      strColumnAlia = "Duration of speech (s)";
      break;
    case "proportion_without_front":
      strColumnAlia = "Proportion Without Front (%)";
      break;
    case "duration_without_front":
      strColumnAlia = "Duration Without Front (s)";
      break;
    case "mean_duration_without_front":
      strColumnAlia = "Mean Duration Without Front (s)";
      break;
    case "proportion_front":
      strColumnAlia = "Proportion Front (%)";
      break;
    case "duration_front_clipping":
      strColumnAlia = "Duration Front Clipping (s)";
      break;
    case "mean_duration_front_clipping":
      strColumnAlia = "Mean Duration Front Clipping (s)";
      break;
    case "proportion_back":
      strColumnAlia = "Proportion Back (%)";
      break;
    case "duration_back_clipping":
      strColumnAlia = "Duration Back Clipping (s)";
      break;
    case "mean_duration_back_clipping":
      strColumnAlia = "Mean Duration Back Clipping (s)";
      break;
    case "duration_hangover":
      strColumnAlia = "Duration Hangover (s)";
      break;
    case "pams_avg_offset":
      strColumnAlia = "PAMS Max Offset (ms)";
      break;
    case "pams_max_offset":
      strColumnAlia = "PAMS Max Offset (ms)";
      break;
    case "pams_min_offset":
      strColumnAlia = "PAMS Min Offset (ms)";
      break;
    case "pams_std_deviation_offsets":
      strColumnAlia = "PAMS Standard Deviation Offsets (ms)";
      break;
    case "pams_proportion_degraded_muted":
      strColumnAlia = "PAMS Proportion degraded muted (%)";
      break;
    case "pams_max_mute":
      strColumnAlia = "PAMS Max Mute (ms)";
      break;
    case "pams_median_offset":
      strColumnAlia = "PAMS Median Offset (ms)";
      break;
    case "psqm_slt_interval_weightfactor":
      strColumnAlia = "PSQM (Silent Interval Weighting) Factor";
      break;
    case "pesqdelay_per_utterance":
      strColumnAlia = "PESQ Delay Per Utterance";
      break;
    case "psqmplus":
      strColumnAlia = "PSQM PLUS";
      break;
    case "dcoss_trunkts":
      strColumnAlia = "DCOSS Trunk/TS";
      break;
    case "rtd_rating":
      strColumnAlia = "Rating";
      break;

    //VQuad
    case "vba_rtd":
    case "rtd":
      strColumnAlia = "RTD (ms)";
      break;
    case "pdd":
      strColumnAlia = "PDD (ms)";
      break;
    case "owd":
      strColumnAlia = "OWD (ms)";
      break;
    case "ct":
      strColumnAlia = "CT (sec)";
      break;
    case "cct":
      strColumnAlia = "CCT (sec)";
      break;
    case "signal_level_gain":
      strColumnAlia = "Signal Gain (dB)";
      break;
    case "line_current":
      strColumnAlia = "Line Current (mA)";
      break;
    case "line_voltage":
      strColumnAlia = "Line Voltage (V)";
      break;
    case "ring_type":
      strColumnAlia = "Ring Type";
      break;
    case "ring_voltage":
      strColumnAlia = "Ring Voltage (V)";
      break;
    case "speech_activity":
      strColumnAlia = "Speech Activity (%)";
      break;
    case "active_speech_level":
      strColumnAlia = "Active Speech level (dB)";
      break;
    case "noise_level_tdm":
      strColumnAlia = "Noise Level (dB)";
      break;
    case "dc_offset":
      strColumnAlia = "DC Offset (dB)";
      break;
    case "total_rms_power":
      strColumnAlia = "Total RMS Power (dB)";
      break;
    case "double_talk":
      strColumnAlia = "Double-Talk";
      break;
    case "ptt_setup_time":
      strColumnAlia = "PTT Setup Time (ms)";
      break;
    case "audio_bw":
      strColumnAlia = "Frequency Analysis (Hz)";//"Audio Analyzer Bandwidth (Hz)";
      break;
    case "audio_power":
      strColumnAlia = "Power Analysis (dB)";//"Audio Analyzer Power (dB)";
      break;
    case "dropout":
      strColumnAlia = "Audio Dropout";
      break;
    case "vmwi":
      strColumnAlia = "Voice Mail Waiting Indicator";
      break;
    case "sdt":
      strColumnAlia = "Stutter DialTone";
      break;
    case "ptt_conn_time":
      strColumnAlia = "PTT Connection Time (ms)";
      break;
    case "stt_percent":
      strColumnAlia = "Speech Analysis Percent (%)";
      break;
    //VBA
    case "em_elapsed":
      strColumnAlia = "Elapsed (sec)";
      break;
    case "em_asl":
      strColumnAlia = "Active Speech Level (dBm)";
      break;
    case "em_af":
      strColumnAlia = "Activity Factor (%)";
      break;
    case "em_rms":
      strColumnAlia = "RMS Power (dBm)";
      break;
    case "em_noise":
      strColumnAlia = "Noise Level (dBm)";
      break;
    case "psophometric_noise":
      strColumnAlia = "Psophometric Noise (dBm)";
      break;
    case "cmessage_noise":
      strColumnAlia = "C-Message Noise (dBm)";
      break;
    case "em_clip":
      strColumnAlia = "Possibly Clipped Samples";
      break;
    case "em_maxp":
      strColumnAlia = "MaxP (Counts)";
      break;
    case "em_maxn":
      strColumnAlia = "MaxN (Counts)";
      break;
    case "em_dc":
      strColumnAlia = "DC Level (Counts)";
      break;
    case "call_control_event":
      strColumnAlia = "Call Control Event";
      break;
    case "rfactor":
      strColumnAlia = "ITU-T G.107" + "" + " R-Factor";
      break;
    case "rtd_error":
      strColumnAlia = "Condition";
      break;
    case "swr":
      strColumnAlia = "SNR (dB)";
      break;
    case "cc_condition":
      strColumnAlia = "Call Event Condition";
      break;
    case "completedcall":
      strColumnAlia = "Completed Call";
      break;
    case "numbercall":
      strColumnAlia = "Total Call";
      break;
    case "ccallrate":
      strColumnAlia = "Completed Call Rate";
      break;
    case "placecall":
      strColumnAlia = "Placing Call";
      break;
    case "busycall":
      strColumnAlia = "Busy Call";
      break;
    case "totalrecord":
      strColumnAlia = "Total Record";
      break;
    case "nodeip":
      strColumnAlia = "Computer Name";
      break;
    case "nodeversion":
      strColumnAlia = "VQuad Version";
      break;
    case "nodestatus":
      strColumnAlia = "Computer Status";
      break;
    case "appstatus":
      strColumnAlia = "VQuad Status";
      break;
    case "custom_nodeip":
      strColumnAlia = "Computer Name";
      break;
    case "custom_appstatus":
      strColumnAlia = "Application Status";
      break;
    case "apptype":
      strColumnAlia = "Application Name";
      break;
    case "devicename":
      strColumnAlia = "Device Name";
      break;
    case "scriptname":
      strColumnAlia = "Script Name";
      break;
    case "scriptstatus":
      strColumnAlia = "Script Status";
      break;
    case "operationstatus":
      strColumnAlia = "Operation Status";
      break;
    case "nodetimestamp":
    case "apptimestamp":
    case "scripttimestamp":
      strColumnAlia = "Timestamp";
      break;
    case "vba_rating":
      strColumnAlia = "Rating";
      break;
    case "dcoss_timestamp":
      strColumnAlia = "DCOSS Timestamp";
      break;
    //EMUDATA 
    case "startpoint1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Startpoint (secs)";
      break;
    case "endpoint1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Endpoint (secs)";
      break;
    case "block1_erl1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo1 ERL (dB)";
      break;
    case "block1_erl2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo2 ERL (dB)";
      break;
    case "block1_erl3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo3 ERL (dB)";
      break;
    case "block1_erl4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo4 ERL (dB)";
      break;
    case "block1_delay1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo1 Delay (ms)";
      break;
    case "block1_delay2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo2 Delay (ms)";
      break;
    case "block1_delay3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo3 Delay (ms)";
      break;
    case "block1_delay4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block1 ";
      strColumnAlia = blockAppend + "Echo4 Delay (ms)";
      break;

    case "startpoint2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Startpoint (secs)";
      break;
    case "endpoint2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Endpoint (secs)";
      break;
    case "block2_erl1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo1 ERL (dB)";
      break;
    case "block2_erl2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo2 ERL (dB)";
      break;
    case "block2_erl3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo3 ERL (dB)";
      break;
    case "block2_erl4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo4 ERL (dB)";
      break;
    case "block2_delay1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo1 Delay (ms)";
      break;
    case "block2_delay2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo2 Delay (ms)";
      break;
    case "block2_delay3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo3 Delay (ms)";
      break;
    case "block2_delay4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block2 ";
      strColumnAlia = blockAppend + "Echo4 Delay (ms)";
      break;

    case "startpoint3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Startpoint (secs)";
      break;
    case "endpoint3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Endpoint (secs)";
      break;
    case "block3_erl1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo1 ERL (dB)";
      break;
    case "block3_erl2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo2 ERL (dB)";
      break;
    case "block3_erl3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo3 ERL (dB)";
      break;
    case "block3_erl4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo4 ERL (dB)";
      break;
    case "block3_delay1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo1 Delay (ms)";
      break;
    case "block3_delay2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo2 Delay (ms)";
      break;
    case "block3_delay3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo3 Delay (ms)";
      break;
    case "block3_delay4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block3 ";
      strColumnAlia = blockAppend + "Echo4 Delay (ms)";
      break;

    case "startpoint4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Startpoint (secs)";
      break;
    case "endpoint4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Endpoint (secs)";
      break;
    case "block4_erl1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo1 ERL (dB)";
      break;
    case "block4_erl2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo2 ERL (dB)";
      break;
    case "block4_erl3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo3 ERL (dB)";
      break;
    case "block4_erl4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo4 ERL (dB)";
      break;
    case "block4_delay1":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo1 Delay (ms)";
      break;
    case "block4_delay2":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo2 Delay (ms)";
      break;
    case "block4_delay3":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo3 Delay (ms)";
      break;
    case "block4_delay4":
      var blockAppend = "";
      if (DDLorGrid == "DDL")
        blockAppend = "Block4 ";
      strColumnAlia = blockAppend + "Echo4 Delay (ms)";
      break;

    //TCPDATA 
    case "teststatus":
      strColumnAlia = "Test Failed";
      break;
    case "start_timestamp":
      strColumnAlia = "Device Timestamp (Start)";
      break;
    case "start_gps_lat":
      strColumnAlia = "Device Latitude (Start)";
      break;
    case "start_gps_long":
      strColumnAlia = "Device Longitude (Start)";
      break;
    case "start_gps_position":
      strColumnAlia = "Device GPS (Start)";
      break;
    case "net_speed_test": // common column
      strColumnAlia = "Net Speed Test";
      break;
    case "target_server": // common column
      strColumnAlia = "Target Server/IP";
      break;
    case "battery_level": // common column
      strColumnAlia = "Battery Level (%)";
      break;
    case "rssi": // common column
      strColumnAlia = "RSSI (dBm)";
      break;
    case "network_type": // common column
      strColumnAlia = "Network Type";
      break;
    case "tn_number": // common column
      strColumnAlia = "TN Number";
      break;
    case "dwn_speed":
      strColumnAlia = "TCP Download Speed (Mbps)";
      break;
    case "dwn_effective_speed":
      strColumnAlia = "TCP Download Effective Speed (Mbps)";
      break;
    case "dwn_max_delay":
      strColumnAlia = "TCP Download Max Delay (ms)";
      break;
    case "dwn_avg_delay":
      strColumnAlia = "TCP Download Average Delay (ms)";
      break;
    case "dwn_qos_tcp":
      strColumnAlia = "TCP Download QOS (%)";
      break;
    case "dwn_mtu":
      strColumnAlia = "TCP Download MTU (Bytes)";
      break;
    case "dwn_retransmit_timeouts":
      strColumnAlia = "TCP Download Retransmit Timeouts";
      break;
    case "dwn_fast_retransmits":
      strColumnAlia = "TCP Download Fast Retransmits";
      break;
    case "dwn_packets_retransmitted":
      strColumnAlia = "TCP Download Packets Retransmitted";
      break;
    case "dwn_bytes_retransmitted":
      strColumnAlia = "TCP Download Bytes Retransmitted";
      break;
    case "dwn_send_window_closed":
      strColumnAlia = "TCP Download Send Window Closed";
      break;
    case "dwn_window_only_updates_rcvd":
      strColumnAlia = "TCP Download Window Only Updates Rcvd";
      break;
    case "dwn_acks_for_unsent":
      strColumnAlia = "TCP Download Acks for Unsent";
      break;
    case "dwn_duplicate_acks":
      strColumnAlia = "TCP Download Duplicate Acks";
      break;
    case "dwn_window_probes_sent":
      strColumnAlia = "TCP Download Window Probes Sent";
      break;
    case "dwn_persist_timeouts":
      strColumnAlia = "TCP Download Persist Timeouts";
      break;
    case "up_speed":
      strColumnAlia = "TCP Upload Speed (Mbps)";
      break;
    case "up_effective_speed":
      strColumnAlia = "TCP Upload Effective Speed (Mbps)";
      break;
    case "up_max_delay":
      strColumnAlia = "TCP Upload Max Delay (ms)";
      break;
    case "up_avg_delay":
      strColumnAlia = "TCP Upload Average Delay (ms)";
      break;
    case "up_qos_tcp":
      strColumnAlia = "TCP Upload QOS (%)";
      break;
    case "up_mtu":
      strColumnAlia = "TCP Upload MTU (Bytes)";
      break;
    case "up_out_of_order_pkt":
      strColumnAlia = "TCP Upload Out of Order (Packets)";
      break;
    case "up_out_of_order_byt":
      strColumnAlia = "TCP Upload Out of Order (Bytes)";
      break;
    case "up_outside_window_pkt":
      strColumnAlia = "TCP Upload Outside Window (Packets)";
      break;
    case "up_outside_window_byt":
      strColumnAlia = "TCP Upload Outside Window (Bytes)";
      break;
    case "up_pure_duplicate_pkt":
      strColumnAlia = "TCP Upload Pure Duplicate (Packets)";
      break;
    case "up_pure_duplicate_byt":
      strColumnAlia = "TCP Upload Pure Duplicate (Bytes)";
      break;
    case "up_partial_duplicate_pkt":
      strColumnAlia = "TCP Upload Partial Duplicate (Packets)";
      break;
    case "up_partial_duplicate_byt":
      strColumnAlia = "TCP Upload Partial Duplicate (Bytes)";
      break;
    case "up_packets_with_crc_error":
      strColumnAlia = "TCP Upload Packets with CRC Error";
      break;
    case "up_packets_with_bad_offset":
      strColumnAlia = "TCP Upload Packets with Bad Offset";
      break;
    case "up_truncated_packets":
      strColumnAlia = "TCP Upload Truncated Packets";
      break;
    case "up_window_probes_received":
      strColumnAlia = "TCP Upload Window Probes Received";
      break;
    case "up_zero_window_updates_sent":
      strColumnAlia = "TCP Upload Zero Window Updates Sent";
      break;
    case "up_bytes_lost":
      strColumnAlia = "TCP Upload Bytes Lost";
      break;
    case "max_route_speed":
      strColumnAlia = "TCP Max Route Speed (Mbps)";
      break;
    case "round_trip_time":
      strColumnAlia = "TCP Round Trip Time (ms)";
      break;
    case "no_of_sessions":
      strColumnAlia = "TCP No of Sessions";
      break;
    case "equilibrium_efficiency":
      strColumnAlia = "TCP Equilibrium Efficiency";
      break;
    case "capacity_efficiency":
      strColumnAlia = "TCP Capacity Efficiency";
      break;
    case "rtt_consistency":
      strColumnAlia = "TCP RTT Consistency";
      break;
    case "buffer_delay":
      strColumnAlia = "TCP Buffer Delay";
      break;
    case "error_delay":
      strColumnAlia = "TCP Error Delay";
      break;
    case "quality":
      strColumnAlia = "TCP Quality";
      break;

    //UDPDATA - repeated values(TCP) 
    case "dwn_capacity":
      strColumnAlia = "UDP Download Capacity (Mbps)";
      break;
    case "dwn_qos_udp":
      strColumnAlia = "UDP Download QOS (%)";
      break;
    case "dwn_packet_size":
      strColumnAlia = "UDP Download Packet size (Bytes)";
      break;
    case "dwn_packet_per_second":
      strColumnAlia = "UDP Download KiloPackets per sec";
      break;
    case "up_capacity":
      strColumnAlia = "UDP Upload Capacity (Mbps)";
      break;
    case "up_qos_udp":
      strColumnAlia = "UDP Upload QOS (%)";
      break;
    case "up_packet_size":
      strColumnAlia = "UDP Upload Packet size (Bytes)";
      break;
    case "up_packet_per_second":
      strColumnAlia = "UDP Upload KiloPackets per sec";
      break;

    //VOIPDATA 
    case "up_avg_jitter":
      strColumnAlia = "VoIP Upstream Avg Jitter (ms)";
      break;
    case "up_max_jitter":
      strColumnAlia = "VoIP Upstream Max Jitter (ms)";
      break;
    case "up_packets_out_of_order":
      strColumnAlia = "VoIP Upstream Packets Out of Order (%)";
      break;
    case "up_packet_loss":
      strColumnAlia = "VoIP Upstream Packet Loss (%)";
      break;
    case "up_packet_discard":
      strColumnAlia = "VoIP Upstream Packet Discard (%)";
      break;
    case "dwn_avg_jitter":
      strColumnAlia = "VoIP Downstream Avg Jitter (ms)";
      break;
    case "dwn_max_jitter":
      strColumnAlia = "VoIP Downstream Max Jitter (ms)";
      break;
    case "dwn_packets_out_of_order":
      strColumnAlia = "VoIP Downstream Packets Out of Order (%)";
      break;
    case "dwn_packet_loss":
      strColumnAlia = "VoIP Downstream Packet Loss (%)";
      break;
    case "dwn_packet_discard":
      strColumnAlia = "VoIP Downstream Packet Discard (%)";
      break;
    case "sip_register":
      strColumnAlia = "VoIP SIP Register (ms)";
      break;
    case "sip_invite":
      strColumnAlia = "VoIP SIP Invite (ms)";
      break;
    case "sip_bye":
      strColumnAlia = "VoIP SIP Bye (ms)";
      break;

    //ROUTEDATA 
    case "hops":
      strColumnAlia = "Route Hops";
      break;
    case "response_to_end":
      strColumnAlia = "Route Response to End (ms)";
      break;
    case "max_response":
      strColumnAlia = "Route Max Response (ms)";
      break;
    case "loss_to_end":
      strColumnAlia = "Route Loss to End %";
      break;
    case "max_loss":
      strColumnAlia = "Route Max Loss %";
      break;
    case "dns_time":
      strColumnAlia = "Route DNS Time (ms)";
      break;
    case "trace_to_ip":
      strColumnAlia = "Route Trace to IP";
      break;
    case "trace_from_ip":
      strColumnAlia = "Route Trace from IP";
      break;

    //HTTPDATA 
    case "avg_failed_rate":
      strColumnAlia = "HTTP Avg Failed Rate (%)";
      break;
    case "min_total_latency":
      strColumnAlia = "HTTP Min Total Latency (ms)";
      break;
    case "min_connect_latency":
      strColumnAlia = "HTTP Min Connect Latency (ms)";
      break;
    case "min_find_latency":
      strColumnAlia = "HTTP Min Find Latency (ms)";
      break;
    case "min_read_latency":
      strColumnAlia = "HTTP Min Read Latency (ms)";
      break;
    case "avg_total_latency":
      strColumnAlia = "HTTP Avg Total Latency (ms)";
      break;
    case "avg_connect_latency":
      strColumnAlia = "HTTP Avg Connect Latency (ms)";
      break;
    case "avg_find_latency":
      strColumnAlia = "HTTP Avg Find Latency (ms)";
      break;
    case "avg_read_latency":
      strColumnAlia = "HTTP Avg Read Latency (ms)";
      break;
    case "max_total_latency":
      strColumnAlia = "HTTP Max Total Latency (ms)";
      break;
    case "max_connect_latency":
      strColumnAlia = "HTTP Max Connect Latency (ms)";
      break;
    case "max_find_latency":
      strColumnAlia = "HTTP Max Find Latency (ms)";
      break;
    case "max_read_latency":
      strColumnAlia = "HTTP Max Read Latency (ms)";
      break;
    case "avg_bytes_read":
      strColumnAlia = "HTTP Avg Bytes Read";
      break;
    case "avg_read_rate":
      strColumnAlia = "HTTP Avg Read Rate (kBps)";
      break;
    case "min_read_rate":
      strColumnAlia = "HTTP Min Read Rate (kBps)";
      break;
    case "max_read_rate":
      strColumnAlia = "HTTP Max Read Rate (kBps)";
      break;
    case "number_of_tests_http":
      strColumnAlia = "HTTP Number of Tests";
      break;

    //FTPDATA 
    case "latency":
      strColumnAlia = "FTP Latency (ms)";
      break;
    case "failure":
      strColumnAlia = "FTP Failure (%)";
      break;
    case "method":
      strColumnAlia = "FTP Mode";
      break;
    case "data_read_kb":
      strColumnAlia = "FTP Data Read (kB)";
      break;
    case "data_write_kb":
      strColumnAlia = "FTP Data Write (kB)";
      break;
    case "data_read_kbps":
      strColumnAlia = "FTP Data Read (kBps)";
      break;
    case "data_write_kbps":
      strColumnAlia = "FTP Data Write (kBps)";
      break;
    case "rtt_min_ftp":
      strColumnAlia = "FTP RTT Min (ms)";
      break;
    case "rtt_avg_ftp":
      strColumnAlia = "FTP RTT Avg (ms)";
      break;
    case "rtt_max_ftp":
      strColumnAlia = "FTP RTT Max (ms)";
      break;

    //DNSDATA 
    case "query_name":
      strColumnAlia = "DNS Query Name";
      break;
    case "min_latency":
      strColumnAlia = "DNS Min Latency (ms)";
      break;
    case "avg_latency":
      strColumnAlia = "DNS Avg Latency (ms)";
      break;
    case "max_latency":
      strColumnAlia = "DNS Max Latency (ms)";
      break;
    case "failure_dns":
      strColumnAlia = "DNS Failure (%)";
      break;
    case "number_of_tests_dns":
      strColumnAlia = "DNS Number of Tests";
      break;

    //SMSDATA 
    case "total_msg_send":
      strColumnAlia = "SMS Total Messages Send";
      break;
    case "total_msg_failed":
      strColumnAlia = "SMS Total Messages Failed";
      break;
    case "min_time_sms":
      strColumnAlia = "SMS Minimum Time (Secs)";
      break;
    case "avg_time_sms":
      strColumnAlia = "SMS Average Time (Secs)";
      break;
    case "max_time_sms":
      strColumnAlia = "SMS Maximum Time (Secs)";
      break;
    case "total_msg_recieved":
      strColumnAlia = "SMS Total Messages Received";
      break;
    case "total_recievesms_expected":
      strColumnAlia = "SMS Total Messages Expected to Recieve";
      break;
    case "time_of_firstsms":
      strColumnAlia = "SMS Time of First Message";
      break;
    case "time_of_lastsms":
      strColumnAlia = "SMS Time of Last Message";
      break;

    //EMAILDATA 
    case "total_emails_send":
      strColumnAlia = "EMAIL Total Emails Send";
      break;
    case "total_emails_failed":
      strColumnAlia = "EMAIL Total Emails Failed";
      break;
    case "min_time_sendemail":
      strColumnAlia = "EMAIL Minimum Sent Time (Secs)";
      break;
    case "avg_time_sendemail":
      strColumnAlia = "EMAIL Average Sent Time (Secs)";
      break;
    case "max_time_sendemail":
      strColumnAlia = "EMAIL Maximum Sent Time (Secs)";
      break;
    case "total_emails_recieved":
      strColumnAlia = "EMAIL Total Emails Received";
      break;
    case "total_recieveemails_expected":
      strColumnAlia = "EMAIL Total Emails Expected to Recieve";
      break;
    case "time_of_firstemail":
      strColumnAlia = "EMAIL Time of First Email";
      break;
    case "time_of_lastemail":
      strColumnAlia = "EMAIL Time of Last Email";
      break;

    //PHONEINFO 
    case "mobile_results": //common column in infos
      strColumnAlia = "Mobile Results";
      break;
    case "phone_model": //common column in infos
      strColumnAlia = "Phone Model";
      break;
    case "phone_ios_version":
      strColumnAlia = "PHONEINFO Phone S/W Version";
      break;
    case "app_version":
      strColumnAlia = "PHONEINFO App Version";
      break;
    case "imei":
      strColumnAlia = "PHONEINFO IMEI";
      break;

    //SIMINFO 
    case "simmnc":
      strColumnAlia = "SIM MNC";
      break;
    case "simmcc":
      strColumnAlia = "SIM MCC";
      break;
    case "imsi":
      strColumnAlia = "SIM IMSI";
      break;

    //UEINFO 
    case "egci":
      strColumnAlia = "UE EGCI";
      break;
    case "plmn_id":
      strColumnAlia = "UE PLMN ID";
      break;
    case "cell_id":
      strColumnAlia = "UE Cell/Base Station ID";
      break;
    case "neighbouring_cell_id":
      strColumnAlia = "UE Neighbouring Cell ID";
      break;
    case "lai":
      strColumnAlia = "UE LAI";
      break;
    case "ipaddress":
      strColumnAlia = "UE IP Address";
      break;
    case "gateway":
      strColumnAlia = "UE Gateway";
      break;
    case "dns_ue":
      strColumnAlia = "UE DNS";
      break;

    //FAXDATA 
    case "fax_event":
      strColumnAlia = "Event";
      break;
    case "fax_duration":
      strColumnAlia = "Duration (sec)";
      break;
    case "fax_error":
      strColumnAlia = "Error";
      break;
    case "ecm":
      strColumnAlia = "ECM";
      break;
    case "modem":
      strColumnAlia = "Modem";
      break;
    case "starting_speed":
      strColumnAlia = "Starting Speed";
      break;
    case "final_speed":
      strColumnAlia = "Final Speed";
      break;
    case "completed_pages":
      strColumnAlia = "Completed Pages";
      break;
    case "sent_lines":
      strColumnAlia = "Tx/Rx Lines";
      break;
    case "bad_lines":
      strColumnAlia = "Bad Lines";
      break;
    case "encoding":
      strColumnAlia = "Encoding";
      break;
    case "resolution":
      strColumnAlia = "Resolution";
      break;

    //VQTPOLQA 
    case "deg_file_name":
      strColumnAlia = "Degraded Filename";
      break;
    case "polqa_score":
      strColumnAlia = "POLQA MOS";//POLQA Score
      break;
    case "polqa_v3":
      strColumnAlia = "POLQA v3 MOS";//POLQA v3
      break;
    case "pass_or_fail":
      strColumnAlia = "Rating";
      break;
    case "jitter_min":
      strColumnAlia = "Max Neg Jitter (ms)";
      break;
    case "jitter_max":
      strColumnAlia = "Max Pos Jitter (ms)";
      break;
    case "jitter_ave":
      strColumnAlia = "Jitter Ave (ms)";
      break;
    case "emodel_polqa":
      strColumnAlia = "EModel (R-factor)";
      break;
    case "speech_level_diff":
      strColumnAlia = "Speech Level Gain (dB)";
      break;
    case "snr_diff":
      strColumnAlia = "Noise Level Gain (dB)";
      break;
    case "asr_ref":
      strColumnAlia = "Active Speech Ratio - Ref (%)";
      break;
    case "asr_deg":
      strColumnAlia = "Active Speech Ratio - Deg (%)";
      break;
    case "number_of_utterance":
      strColumnAlia = "Number of Utterance";
      break;
    case "delay_min":
      strColumnAlia = "Per Utterance Delay Min (ms)";
      break;
    case "delay_max":
      strColumnAlia = "Per Utterance Delay Max (ms)";
      break;
    case "delay_ave":
      strColumnAlia = "Per Utterance Delay Ave (ms)";
      break;
    case "polqa_owd":
      strColumnAlia = "POLQA OWD (ms)";
      break;
    //case "polqa_sa_ref":
    //    strColumnAlia = "Speech Activity - Ref (%)";
    //    break;
    //case "polqa_sa_deg":
    //    strColumnAlia = "Speech Activity - Deg (%)";
    //    break;
    case "polqa_asl_ref":
      strColumnAlia = "Active Speech Level - Ref (dBm)";
      break;
    case "polqa_asl_deg":
      strColumnAlia = "Active Speech Level - Deg (dBm)";
      break;
    case "polqa_mnl_ref":
      strColumnAlia = "Mean Noise Level - Ref (dBm)";
      break;
    case "polqa_mnl_deg":
      strColumnAlia = "Mean Noise Level - Deg (dBm)";
      break;
    case "polqa_snr_ref":
      strColumnAlia = "SNR - Ref (dB)";
      break;
    case "polqa_snr_deg":
      strColumnAlia = "SNR - Deg (dB)";
      break;

    //VAC
    case "relative_mos_v":
      strColumnAlia = "Relative MOS-V";
      break;
    case "absolute_mos_v":
      strColumnAlia = "Absolute MOS-V";
      break;
    case "relative_mos_a":
      strColumnAlia = "Relative MOS-A";
      break;
    case "relative_mos_av":
      strColumnAlia = "Relative MOS-AV";
      break;
    case "endpoint_uri":
      strColumnAlia = "Endpoint Name";
      break;
    case "ip_address":
      strColumnAlia = "IP Address (Port)";
      break;
    case "vlan_encap":
      strColumnAlia = "VLAN Encap/ID/CoS";
      break;
    case "endpoint_ua":
      strColumnAlia = "Endpoint/UA Type";
      break;
    case "image_size":
      strColumnAlia = "Image Size (Width X Height)";
      break;
    case "video_packet_loss_rate":
      strColumnAlia = "Video Packet Loss Rate (%)";
      break;
    case "video_discard_rate":
      strColumnAlia = "Video Discard Rate (%)";
      break;
    case "video_bandwidth":
      strColumnAlia = "Video Bandwidth (kbps)";
      break;
    case "video_frame_rate":
      strColumnAlia = "Video Frame Rate (Frames per Second)";
      break;
    case "impaired_i_frames":
      strColumnAlia = "Impaired I Frames (%)";
      break;
    case "impaired_bp_frames":
      strColumnAlia = "Impaired B/P Frames (%)";
      break;
    case "loss_rate_within_i_frames":
      strColumnAlia = "Loss Rate within I Frames (%)";
      break;
    case "loss_rate_within_bp_frames":
      strColumnAlia = "Loss Rate within B/P Frames (%)";
      break;
    case "g1070_video_mos":
      strColumnAlia = "G.1070 Video MOS";
      break;
    case "bp_frames_received":
      strColumnAlia = "B/P Frames Received";
      break;
    case "audio_packet_loss_rate":
      strColumnAlia = "Audio Packet Loss Rate (%)";
      break;
    case "audio_discard_rate":
      strColumnAlia = "Audio Discard Rate (%)";
      break;
    case "audio_bitrate":
      strColumnAlia = "Audio Bitrate (kbps)";
      break;
    case "audio_bandwidth":
      strColumnAlia = "Audio Bandwidth (kHz)";
      break;
    case "signal_level":
      strColumnAlia = "Signal Level (dBm0)";
      break;
    case "noise_level":
      strColumnAlia = "Noise Level (dBm0)";
      break;
    case "g1070_audio_mos":
      strColumnAlia = "G.1070 Audio MOS";
      break;
    case "total_round_trip_delay":
      strColumnAlia = "Total Round Trip Delay (ms)";
      break;
    case "end_system_delay":
      strColumnAlia = "End System Delay (ms)";
      break;
    case "network_round_trip_delay":
    case "network_round_trip_delay_av":
      strColumnAlia = "Network Round Trip Delay (ms)";
      break;
    case "network_packet_loss_rate":
      strColumnAlia = "Network Packet Loss Rate (%)";
      break;
    case "network_packet_discard_rate":
      strColumnAlia = "Network Packet Discard Rate (%)";
      break;
    case "network_packet_duplicate_rate":
      strColumnAlia = "Network Packet Duplicate Rate (%)";
      break;
    case "network_packet_reorder_rate":
      strColumnAlia = "Network Packet Reorder Rate (%)";
      break;
    case "mean_burst_loss_rate":
      strColumnAlia = "Mean Burst Loss Rate (%)";
      break;
    case "mean_burst_length":
      strColumnAlia = "Mean Burst Length (Packets)";
      break;
    case "mean_gap_loss_rate":
      strColumnAlia = "Mean Gap Loss Rate (%)";
      break;
    case "mean_gap_length":
      strColumnAlia = "Mean Gap Length (Packets)";
      break;
    case "jitter__ppdv_":
      strColumnAlia = "Jitter (PPDV) (ms)";
      break;
    case "mapdv_avg":
      strColumnAlia = "MAPDV Avg (ms)";
      break;
    case "service_access_delay":
      strColumnAlia = "Service Access Delay (ms)";
      break;
    case "session_disconnect_delay":
      strColumnAlia = "Session Disconnect Delay (ms)";
      break;
    case "image_resolution":
      strColumnAlia = "Image Resolution (Pixels)";
      break;
    case "audio_packet_duration":
      strColumnAlia = "Audio Packet Duration (ms)";
      break;
    default:
      strColumnAlia = strColumnName.replace(/\_/g, ' ');
      strColumnAlia = strColumnAlia.replace(/BSH/gi, '/');
      break;
  }
  return strColumnAlia;
}
function GetTitleBgColorOrColor(colIndex, rsltTypeChk, type) {
  if ((rsltTypeChk === 'emu' && ((colIndex >= 17 && colIndex <= 26)
    || (colIndex >= 37 && colIndex <= 46)))
    || (rsltTypeChk === 'vac' && ((colIndex >= 17 && colIndex <= 23)
      //|| (colIndex >= 29 && colIndex <= 30)
      //|| (colIndex >= 38 && colIndex <= 43)
    || (colIndex == 28)
    || (colIndex >= 36 && colIndex <= 41)
    ))) {
    if (type === 0)
      return '#E9EBEC';
    else
      return 'black';
  }
  else {
    if (type === 0)
      return '#6D96D6';//5b9bd5
    else
      return 'white';
  }
}

export function headersNTypes(cols, rsltType, DAQOrNot?: boolean): Column[] {
  let daqParam = "";
  if (DAQOrNot)
    daqParam = "DAQ;";
  let pesqDisplaySet = ";Deg_File_Name;Rating;PESQ_Score;" + daqParam + "PESQ_LQ;PESQ_MOS;PESQ_WB;PSQMPLUS;PESQ_Average_offset;PESQ_Max_Offset;PESQ_Min_Offset;Number_All_clipping;" +
    "Duration_ALL_Clipping;Mean_Duration_ALL_Clipping;duration_hangover;Number_of_hangover;Average_Jitter;RSSI;";//To be displayed on main screen PESQ

  let columnsHeaders: Column[] = [];
  //console.log(Object.getOwnPropertyNames(cols));
  //colSpecialCharsPipe;
  let colIndex = -1;
  Object.keys(cols).forEach(key => {

    colIndex++;

    let tableHid = false;//display

    let colType = typeOfObject(cols[key]);

    let lowerKey = key.toLowerCase();
    if (rsltType.indexOf('_advFilter') != -1) {//adding most of pesq, polqa column under Filters -> Advanced Filter section
      if (lowerKey.indexOf('_timestamp') != -1 || lowerKey.indexOf('vquad_') != -1 || lowerKey.indexOf('gps_') != -1 || lowerKey.indexOf('calltype_') != -1
        || lowerKey.indexOf('deg_file_name') != -1)
        tableHid = true;
    }
    else {
      if (rsltType == 'pesq') {//only few columns to be displayed an rest of columns comes under dyn column adding
        if (pesqDisplaySet.indexOf(';' + key + ';') != -1
          || lowerKey.indexOf('_timestamp') != -1 || lowerKey.indexOf('vquad_') != -1 || lowerKey.indexOf('gps_') != -1 || lowerKey.indexOf('calltype_') != -1
          || lowerKey.indexOf('deg_file_name') != -1)
          tableHid = false;
        else
          tableHid = true;
      }
      else//other than pesq result
        tableHid = false;
    }

    if (key !== "ID") {

      let c: Column = {
        title: GetMapColumnAliia(key, rsltType, "Grid"),
        titleBgColor: GetTitleBgColorOrColor(colIndex, rsltType, 0),
        titleColor: GetTitleBgColorOrColor(colIndex, rsltType, 1),
        name: key,
        type: colType,
        sortable: true,
        //frozen: key.indexOf('VQuad_Timestamp') !== -1 ? true : false, - IMP //https://sreyaj.dev/implement-sticky-columns-using-directives-angular
        tableHidden: tableHid,
        filter: (key.indexOf('GPS_Position') !== -1 || key.indexOf('VQuad_Lat_Long') !== -1 || key.indexOf('GPS_Long') !== -1 || key.indexOf('GPS_Lat') !== -1 || key.indexOf('Time_of_') !== -1) ? false : isFilterableCol(cols[key])//Disable Filter Icon - IMP
      };
      if (rsltType == 'pesq' && key == 'Rating' || rsltType == 'polqa' && key == 'Pass_Or_Fail') {
        c.type = 'select';
        c.options = [
          { id: 'Poor', name: 'Poor' },
          { id: 'Fair', name: 'Fair' },
          { id: 'Good', name: 'Good' },
          { id: 'Excellent', name: 'Excellent' },
        ];
      }
      else if (rsltType == 'audio-delay' && key == 'Ring_Type') {
        c.type = 'select';
        c.options = [
          { id: 'RMS', name: 'RMS' },
          { id: 'Peak', name: 'Peak' },
        ];
      }
      else if (rsltType == 'vba' && key == 'VBA_Rating'
        || rsltType == 'audio-delay' && (key == 'RTD_Rating' || key == 'Speech_Analysis' || key == 'Double_Talk')) {// || key == 'Dropout'
        c.type = 'select';
        c.options = [
          { id: 'Pass', name: 'Pass' },
          { id: 'Fail', name: 'Fail' },
        ];
        if (rsltType == 'audio-delay')
          c.options.push({ id: 'Error', name: 'Error' });
      }
      else if (rsltType == 'nettest' && (key == 'Equilibrium_Efficiency' || key == 'Capacity_Efficiency' || key == 'RTT_Consistency' || key == 'Buffer_Delay' || key == 'Error_Delay' || key == 'Quality')) {
        c.type = 'select';
        c.options = [
          { id: 'Good', name: 'Good' },
          { id: 'Warning', name: 'Warning' },
          { id: 'Fail', name: 'Fail' },
          { id: 'Critical', name: 'Critical' },
        ];
      }
      columnsHeaders.push(c);
    }
  });
  //console.log(columnsHeaders[0]);
  return columnsHeaders;
}

//https://aliolicode.com/2016/04/23/type-checking-typescript/
function typeOfObject(value: string | number | Date | boolean): ColumnType {
  if (typeof value === "string") {
    return "text";
  } else if (typeof value === "number") {
    return "number";
  } else if (value instanceof Date) {
    return "datetime-local";
  } else
    return "radio";
}
function isFilterableCol(value: string | number | Date | boolean): boolean {
  if (value instanceof Date) {
    return false;
  } else
    return true;
}

//https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}




////https://stackoverflow.com/questions/53128744/typescript-automatically-get-interface-properties-in-a-class
//function autoImplement<T>(defaults?: Partial<T>) {
//  return class {
//    constructor() {
//      Object.assign(this, defaults || {});
//    }
//  } as new () => T
//}
//export class VQUADDATA extends autoImplement<IVQUADDATA>() {
//  constructor(vquaddata: any) {
//    super();
//    // other init here
//  }
//}

////https://stackoverflow.com/questions/45670705/typescript-iterate-interface-properties
//const Activity = {
//  id: "",
//  title: "",
//  body: "",
//}

//type Activity = typeof Activity;
//export const headers: Array<Object> = Object.keys(Activity).map(key => {
//  return { text: key, value: key }
//});


//https://mariusschulz.com/blog/keyof-and-lookup-types-in-typescript
function typesOfHeaders() {
  //https://dmitripavlutin.com/how-to-iterate-easily-over-object-properties-in-javascript/
  let meals = {
    mealA: 'Breakfast',
    mealB: 'Lunch',
    mealC: 'Dinner',
    mealD: 'Supper'
  };

  for (let [key, value] of Object.entries(meals)) {
    console.log(key + ':' + value);
  }

  //type TodoKeys = keyof VQUADDATA;

  const vquaddata = {
    VQuad_Timestamp: new Date(),
    GPS_Position: "dkfhhf",
    GPS_Lat: 12,
    GPS_Long: -72,
  };

  const id = prop(vquaddata, "VQuad_Timestamp");     // number
  const text = prop(vquaddata, "GPS_Position"); // string
  const due = prop(vquaddata, "GPS_Lat");   // Date

}
function prop<T, K extends keyof T>(obj: T, key: K) {
  console.log(obj[key]);
  return obj[key];
}
